import {PropTypes} from 'rlink-react';
import {mergeStaticOptions} from 'rlink-utils/object';

import URLPathInput from './URLPathInput';

export default class URLInput extends URLPathInput {
  get external () {
    return this.fromPropsOrContext('external');
  }

  get urlValidationString () {
    return /\s/;
  }

  get inputType () {
    return 'url';
  }
}

mergeStaticOptions(URLInput, {
  propTypes: {
    external: PropTypes.bool,
  },
});



// WEBPACK FOOTER //
// ./lib/rlink-forms/inputs/URLInput.jsx